import { UAParser } from "@ua-parser-js/pro-business";

const apple = [
  { make: "Apple", model: "iPhone 14 Pro Max", width: 430, height: 932 },
  // { make: "Apple", model: "iPhone 14 Plus", width: 428, height: 926 },

  { make: "Apple", model: "iPhone 14 Pro", width: 393, height: 852 },
  {
    make: "Apple",
    model: "iPhone 13 Pro Max / 14 Plus",
    width: 428,
    height: 926,
  },
  { make: "Apple", model: "iPhone 13 Pro", width: 390, height: 844 },
  { make: "Apple", model: "iPhone 13", width: 390, height: 844 },
  { make: "Apple", model: "iPhone 13 Mini", width: 375, height: 812 },
  { make: "Apple", model: "iPhone 12 Pro Max", width: 428, height: 926 },

  { make: "Apple", model: "iPhone 12 Pro", width: 390, height: 844 },
  { make: "Apple", model: "iPhone 12", width: 390, height: 844 },
  { make: "Apple", model: "iPhone 12 Mini", width: 375, height: 812 },
  {
    make: "Apple",
    model: "iPhone SE (2nd generation)",
    width: 375,
    height: 667,
  },
  { make: "Apple", model: "iPhone 11 Pro Max", width: 414, height: 896 },
  { make: "Apple", model: "iPhone 11 Pro", width: 375, height: 812 },
  { make: "Apple", model: "iPhone 11", width: 414, height: 896 },
  { make: "Apple", model: "iPhone XR", width: 414, height: 896 },
  { make: "Apple", model: "iPhone XS Max", width: 414, height: 896 },
  { make: "Apple", model: "iPhone XS", width: 375, height: 812 },
  { make: "Apple", model: "iPhone X", width: 375, height: 812 },
  { make: "Apple", model: "iPhone 8 Plus", width: 414, height: 736 },
  { make: "Apple", model: "iPhone 8", width: 375, height: 667 },
  { make: "Apple", model: "iPhone 7 Plus", width: 414, height: 736 },
  { make: "Apple", model: "iPhone 7", width: 375, height: 667 },
  {
    make: "Apple",
    model: "iPad Pro (12.9-inch) (5th generation)",
    width: 1024,
    height: 1366,
  },
  {
    make: "Apple",
    model: "iPad Pro (11-inch) (3rd generation)",
    width: 834,
    height: 1194,
  },
  {
    make: "Apple",
    model: "iPad Air (4th generation)",
    width: 820,
    height: 1180,
  },
  { make: "Apple", model: "iPad (9th generation)", width: 810, height: 1080 },
  { make: "Apple", model: "iPad (8th generation)", width: 810, height: 1080 },
  {
    make: "Apple",
    model: "iPad Mini (6th generation)",
    width: 768,
    height: 1024,
  },
];

const samsung = [
  { make: "Samsung", model: "Galaxy S21 Ultra", width: 720, height: 1600 },
  { make: "Samsung", model: "Galaxy S21+", width: 540, height: 1200 },
  { make: "Samsung", model: "Galaxy S21", width: 540, height: 1200 },
  { make: "Samsung", model: "Galaxy S20 Ultra", width: 720, height: 1600 },
  { make: "Samsung", model: "Galaxy S20+", width: 720, height: 1600 },
  { make: "Samsung", model: "Galaxy S20", width: 720, height: 1600 },
  { make: "Samsung", model: "Galaxy S10+", width: 720, height: 1520 },
  { make: "Samsung", model: "Galaxy S10", width: 720, height: 1520 },
  { make: "Samsung", model: "Galaxy Note20 Ultra", width: 720, height: 1544 },
  { make: "Samsung", model: "Galaxy Note20", width: 540, height: 1200 },
  { make: "Samsung", model: "Galaxy Note10+", width: 720, height: 1520 },
  { make: "Samsung", model: "Galaxy Note10", width: 540, height: 1140 },
  { make: "Samsung", model: "Galaxy A52 5G", width: 540, height: 1200 },
  { make: "Samsung", model: "Galaxy A72", width: 540, height: 1200 },
  { make: "Samsung", model: "Galaxy Tab S7+", width: 784, height: 1752 },
  { make: "Samsung", model: "Galaxy Tab S7", width: 800, height: 1280 },
  { make: "Samsung", model: "Galaxy Tab S6 Lite", width: 800, height: 1280 },
  { make: "Samsung", model: "Galaxy Tab A7", width: 800, height: 1280 },
];

const google = [
  { make: "Google", model: "Pixel 5", width: 540, height: 1170 },
  { make: "Google", model: "Pixel 4a 5G", width: 540, height: 1170 },
  { make: "Google", model: "Pixel 4a", width: 540, height: 1170 },
  { make: "Google", model: "Pixel 4 XL", width: 720, height: 1520 },
  { make: "Google", model: "Pixel 4", width: 540, height: 1140 },
  { make: "Google", model: "Pixel 3 XL", width: 720, height: 1480 },
  { make: "Google", model: "Pixel 3", width: 540, height: 1080 },
  { make: "Google", model: "Pixel C", width: 1280, height: 1800 },
];

const onePlus = [
  { make: "OnePlus", model: "9 Pro", width: 720, height: 1608 },
  { make: "OnePlus", model: "9", width: 540, height: 1200 },
  { make: "OnePlus", model: "8T", width: 540, height: 1200 },
  { make: "OnePlus", model: "8 Pro", width: 720, height: 1584 },
  { make: "OnePlus", model: "8", width: 540, height: 1200 },
];

const xiaomi = [
  { make: "Xiaomi", model: "Mi 11", width: 720, height: 1600 },
  { make: "Xiaomi", model: "Mi 11 Lite", width: 540, height: 1200 },
  { make: "Xiaomi", model: "Redmi Note 10 Pro", width: 540, height: 1200 },
  { make: "Xiaomi", model: "Redmi Note 10", width: 540, height: 1200 },
  { make: "Xiaomi", model: "Mi Pad 4", width: 1200, height: 1920 },
];

const motorola = [
  { make: "Motorola", model: "Moto G Power (2021)", width: 360, height: 800 },
  { make: "Motorola", model: "Moto G Stylus (2021)", width: 540, height: 1200 },
  { make: "Motorola", model: "Moto G Play (2021)", width: 360, height: 800 },
];

const lg = [
  { make: "LG", model: "Velvet", width: 540, height: 1230 },
  { make: "LG", model: "G8 ThinQ", width: 720, height: 1560 },
  { make: "LG", model: "V40 ThinQ", width: 720, height: 1560 },
  { make: "LG", model: "G Pad 5 10.1", width: 800, height: 1280 },
];

const sony = [
  { make: "Sony", model: "Xperia 5 II", width: 540, height: 1260 },
  { make: "Sony", model: "Xperia 1 II", width: 822, height: 1920 },
  { make: "Sony", model: "Xperia Z4 Tablet", width: 1600, height: 2560 },
];

const nokia = [
  { make: "Nokia", model: "8.3 5G", width: 540, height: 1200 },
  { make: "Nokia", model: "5.4", width: 360, height: 800 },
  { make: "Nokia", model: "3.4", width: 360, height: 800 },
  { make: "Nokia", model: "T20 Tablet", width: 800, height: 1280 },
];

function getDeviceName(
  device: { vendor: string; model: string },
  screenWidth: number,
  screenHeight: number
) {
  const deviceSizes = [
    ...apple,
    ...samsung,
    ...google,
    ...onePlus,
    ...xiaomi,
    ...motorola,
    ...lg,
    ...sony,
    ...nokia,
  ];

  const matchedDevice = deviceSizes.find((_device) => {
    return (
      device.vendor === _device.make &&
      screenWidth === _device.width &&
      screenHeight === _device.height
    );
  });

  if (matchedDevice) {
    return `${matchedDevice.model}`;
  } else if (screenWidth < 768) {
    const parser = new UAParser(window?.navigator?.userAgent); // you need to pass the user-agent for nodejs
    const result = parser.getDevice();
    if (result.vendor && result.model) {
      return `${result.vendor} ${result.model}`;
    }
    return `Phone: ${screenWidth}𝙭${screenHeight}`;
  } else {
    return `Computer: ${screenWidth}𝙭${screenHeight}`;
  }
}

export default getDeviceName;
